export default __webpack_public_path__ + "static/media/9.aba71f4d.jpg";